import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static targets = ["modal", "title", "body", "confirmButton"]

  connect() {
    this.modal = bootstrap.Modal.getOrCreateInstance(this.modalTarget)
  }

  disconnect() {
    this.modal?.dispose()
  }

  open(event) {
    event.preventDefault()
    this.opener = event.currentTarget
    this.titleTarget.textContent = event.params.title || ""
    this.bodyTarget.textContent = event.params.body || ""
    this.confirmButtonTarget.textContent = event.params.confirmLabel || this.confirmButtonTarget.dataset.defaultLabel
    this.modal.show()
  }

  confirm() {
    const opener = this.opener
    if (!opener) return

    this.modalTarget.addEventListener("hidden.bs.modal", () => {
      opener.dispatchEvent(new CustomEvent("confirm-dialog:confirmed", { bubbles: true }))
    }, { once: true })
    this.modal.hide()
    this.opener = null
  }
}
